import { Star, Printer } from "lucide-react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import ProtocolCard from "@/components/protocol/ProtocolCard";

export default function FavoritesPage({ protocols, favorites, onToggleFavorite }) {
  const favoriteProtocols = protocols.filter(p => favorites.some(f => f.protocol_id === p.id));

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-heading text-2xl font-bold flex items-center gap-2">
            <Star className="w-6 h-6 text-yellow-500" />
            Favorites
          </h1>
          <p className="text-muted-foreground">{favoriteProtocols.length} saved protocols</p>
        </div>
        {favoriteProtocols.length > 0 && (
          <Link to="/reference-cards">
            <Button variant="outline" className="gap-2" data-testid="print-ref-cards-btn">
              <Printer className="w-4 h-4" /> Reference Cards
            </Button>
          </Link>
        )}
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {favoriteProtocols.map(protocol => (
          <ProtocolCard 
            key={protocol.id} 
            protocol={protocol}
            isFavorite={true}
            onToggleFavorite={onToggleFavorite}
          />
        ))}
      </div>
      
      {favoriteProtocols.length === 0 && (
        <Card className="p-8 text-center">
          <Star className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground">No favorites yet. Star protocols to save them here.</p>
        </Card>
      )}
    </div>
  );
}
